<template lang="pug">
	.user-actions-log
		.page-center-content(v-if="user && publisher")
			.caption-area
				.back(v-if="Layout.pageOptions.backPage")
					button.btn.btn-sm.btn-ghost-secondary(type="button" @click="Layout.setPage.apply(Layout, Layout.pageOptions.backPage)")
						.icon.fa.fa-angle-double-left
				.caption(:class="{'back-exist': Layout.pageOptions.backPage}") User actions detailed log
				.logo
					img(:src="Publisher.getLogoUrl(publisher)" :alt="publisher.title")
			.publishers-table
				DataTable(name="user-actions-log" entity="monitoring_actions" :fields="fields" :filters="filters" :buttons="buttons" key-field="id" :sort="['date', 'desc']" :update-on="['Layout Page Showed:user-actions-log', 'User Actions Log Filters Ready']" :update-if="() => Layout.page === 'user-actions-log'" :height-offset="Layout.headerHeight + 45")

</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Publisher } 		from './../../services/Publisher'

	import DataTable			from './../../components/Templates/DataTable'

	export default {
		name: "UserActionsLog",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Page Showed:user-actions-log", "Publishers Changed"]
		},
		components: {
			DataTable
		},
		data() {

			this.fields = [
				{
					fieldName: 'id',
					title: 'ID',
					type: 'number',
					display: false,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '70px'
				},
				{
					fieldName: 'date',
					title: 'Date',
					type: 'date',
					class: 'date-only',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '100px'
				},
				{
					fieldName: 'type',
					title: 'Log type',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '150px'
				},
				{
					fieldName: 'title',
					title: 'Title',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false,
					width: '250px'
				},
				{
					fieldName: 'description',
					title: 'Description',
					type: 'string',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false
				},
				{
					fieldName: 'data',
					title: 'Details',
					type: 'button:confirm',
					display: true,
					sortingAllowed: false,
					filteringAllowed: false
				}
			];

			this.filters = [{
				title: 'User',
				field: 'user_id',
				type: 'equal',
				value: 0,
				display: false
			}, {
				title: 'Type',
				field: 'type',
				type: 'in',
				value: '',
				options: [
					{title: '', value: ''},
					{title: 'Download', value: 'download'},
					{title: 'Upload', value: 'upload'},
					{title: 'Navigation', value: 'navigation'},
					{title: 'Publisher', value: 'publisher'},
					{title: 'User', value: 'user'},
					{title: 'Creative', value: 'project'},
					{title: 'Version', value: 'version'},
					{title: 'Settings', value: 'settings'},
					{title: 'Localization', value: 'localization'},
					{title: 'Assets', value: 'assets'},
					{title: 'Preview', value: 'preview'},
					{title: 'Availability', value: 'availability'},
					{title: 'System', value: 'system'},
					{title: 'Error', value: 'error'}
				],
				display: true
			}];

			this.buttons = [];

			this.user = null;
			this.publisher = null;

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

				if (Layout.page === 'user-actions-log' && Layout.pageOptions?.userId) {

					this.userId = Layout.pageOptions.userId;

				} else if (User.currentUser) {

					this.userId = User.currentUser.id;

				} else {

					this.userId = null;

				}

				this.user = User.getUser(this.userId);

				this.publisher = Publisher.getPublisher(this.user?.['publisher_id']);

				if (this.user) {

					let oldValue = this.filters[0].value;

					this.filters[0].value = this.user.id;

					if (!oldValue) Broadcast.call('User Actions Log Filters Ready');

				}

			},
			publisherClick(user) {

				Publisher.switchPublisher(Publisher.findPublisher(user['publisher_id']));

			},
			openUserProfile(user) {

				Layout.setPage('user-profile', {userId: user.id, backPage: ['user-actions-log', {}]});

			},
			activateUser(user) {

				Server.sendToSocket({
					SetUserStatus: {
						userId: user.id,
						active: user.active
					}
				})

			}
		}
	}
</script>

<style lang="sass" scoped>

	.user-actions-log
		display: flex !important
		justify-content: center
		color: #fff

		.page-center-content
			width: 100%
			max-width: 1000px
			height: fit-content
			min-height: 100%
			background-color: #3a4149
			border-left: 1px solid rgba(0, 0, 0, 0.3)
			border-right: 1px solid rgba(0, 0, 0, 0.3)

			.caption-area
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				justify-content: flex-start
				background-color: #343b41
				border-bottom: 1px solid rgba(0, 0, 0, 0.3)

				.back
					display: flex
					align-items: center
					justify-content: center
					padding: 0.2rem 1rem

					button
						width: 30px
						height: 30px

				.caption
					padding: 1rem

				.caption.back-exist
					padding: 1rem 0

				.logo
					display: flex
					margin-left: auto
					padding: 10px

					img
						display: flex
						height: 33px
						margin: 0 10px
						align-items: center
						color: #fff
						padding-left: 10px
						text-transform: uppercase

			.publishers-table
				display: flex
				flex-direction: row
				flex-wrap: wrap
				padding: 1rem 0

</style>

